import React from "react";
import {
  Popper,
  Paper,
  Box,
  Typography,
  Divider,
  ClickAwayListener,
  useTheme,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import * as Constant from "../../features/constant";

const CATEGORIES = [
  { code: "PROMOTION", labelKey: "messaging.promotions", fallback: "Promotions" },
  { code: "PAYMENT", labelKey: "messaging.payment", fallback: "Payment" },
  { code: "SYSTEM", labelKey: "messaging.system", fallback: "System" },
  { code: "NOTIFICATION", labelKey: "messaging.notification", fallback: "Notification" },
  { code: "REWARDS_CLUB", labelKey: "messaging.rewardsclub", fallback: "Rewards Club" },
];

const NotificationDropdown = ({ anchorEl, open, onClose, counts }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const navigate = useNavigate();

  const handleCategoryClick = (categoryCode) => {
    onClose();
    navigate(Constant.getPath(`/messaging?category=${categoryCode}`));
  };

  if (!open) return null;

  return (
    <Popper
      open={open}
      anchorEl={anchorEl}
      placement="bottom-end"
      style={{ zIndex: 1300 }}
    >
      <ClickAwayListener onClickAway={onClose}>
        <Paper
          elevation={4}
          sx={{
            width: 240,
            borderRadius: 2,
            overflow: "hidden",
            mt: 1,
            bgcolor: process.env.REACT_APP_COLOR_BACKGROUND_TERTIARY || theme.palette.background.paper,
          }}
        >
          {CATEGORIES.map((cat, index) => {
            const count = counts?.[cat.code] || 0;
            return (
              <React.Fragment key={cat.code}>
                <Box
                  onClick={() => handleCategoryClick(cat.code)}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 2.5,
                    py: 1.5,
                    cursor: "pointer",
                    "&:hover": {
                      backgroundColor: `${theme.palette.primary.main}15`,
                    },
                  }}
                >
                  <Typography
                    variant="body2"
                    sx={{
                      color: process.env.REACT_APP_COLOR_TEXT || "white",
                      fontSize: "14px",
                    }}
                  >
                    {t(cat.labelKey, cat.fallback)}
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      color: count > 0 ? "#d32f2f" : (process.env.REACT_APP_COLOR_TEXT || "white"),
                      fontWeight: count > 0 ? 600 : 400,
                      fontSize: "14px",
                      opacity: count > 0 ? 1 : 0.6,
                    }}
                  >
                    {count}
                  </Typography>
                </Box>
                {index < CATEGORIES.length - 1 && (
                  <Divider sx={{ mx: 1, borderColor: theme.palette.divider1 }} />
                )}
              </React.Fragment>
            );
          })}
        </Paper>
      </ClickAwayListener>
    </Popper>
  );
};

export default NotificationDropdown;
